import React from 'react';

import OperatorAlgarIcon from '@portal/assets/svg/operators/algar-telecom.svg?react';
import OperatorEmbratelIcon from '@portal/assets/svg/operators/embratel.svg?react';

import OperatorClaroMovelIcon from '@portal/assets/svg/operators/claro-movel.svg?react';
import OperatorClaroTvIcon from '@portal/assets/svg/operators/claro-tv.svg?react';
import OperatorCorreiosIcon from '@portal/assets/svg/operators/correios.svg?react';
import OperatorGooglePlayIcon from '@portal/assets/svg/operators/google-play.svg?react';
import LeagueOfLegendsPng from '@portal/assets/svg/operators/league-of-legends.svg?react';
import OperatorOiIcon from '@portal/assets/svg/operators/oi.svg?react';
import OperatorPlaystationIcon from '@portal/assets/svg/operators/playstation.svg?react';
import OperatorSercomtelIcon from '@portal/assets/svg/operators/sercomtel.svg?react';
import OperatorSkyIcon from '@portal/assets/svg/operators/sky.svg?react';
import OperatorSteamIcon from '@portal/assets/svg/operators/steam.png';
import OperatorSurfTelecomIcon from '@portal/assets/svg/operators/surf.svg?react';
import OperatorTimIcon from '@portal/assets/svg/operators/tim.svg?react';
import OperatorUberIcon from '@portal/assets/svg/operators/uber.png';
import OperatorVivoIcon from '@portal/assets/svg/operators/vivo.svg?react';
import OperatorXboxIcon from '@portal/assets/svg/operators/xbox.svg?react';

export type OperatorIconEntry =
  | {
      type: 'svg';
      component: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    }
  | { type: 'image'; src: string };

const OPERATOR_ICONS: Record<string, OperatorIconEntry> = {
  'algar cel': { type: 'svg', component: OperatorAlgarIcon },
  'algar fixo': { type: 'svg', component: OperatorAlgarIcon },
  claro: { type: 'svg', component: OperatorClaroMovelIcon },
  'claro tv': { type: 'svg', component: OperatorClaroTvIcon },
  correios: { type: 'svg', component: OperatorCorreiosIcon },
  embratel: { type: 'svg', component: OperatorEmbratelIcon },
  'google play': { type: 'svg', component: OperatorGooglePlayIcon },
  'league of legends': { type: 'svg', component: LeagueOfLegendsPng },
  oi: { type: 'svg', component: OperatorOiIcon },
  'oi tv': { type: 'svg', component: OperatorOiIcon },
  'psn store': { type: 'svg', component: OperatorPlaystationIcon },
  'sercomtel fixo': { type: 'svg', component: OperatorSercomtelIcon },
  'sky tv': { type: 'svg', component: OperatorSkyIcon },
  steam: { type: 'image', src: OperatorSteamIcon },
  tim: { type: 'svg', component: OperatorTimIcon },
  uber: { type: 'image', src: OperatorUberIcon },
  vivo: { type: 'svg', component: OperatorVivoIcon },
  'xbox live': { type: 'svg', component: OperatorXboxIcon },
  'xbox live (csv)': { type: 'svg', component: OperatorXboxIcon },
  'surf telecom': { type: 'svg', component: OperatorSurfTelecomIcon },
};

export const getOperatorIcon = (
  name: string
): OperatorIconEntry | undefined => {
  return OPERATOR_ICONS[name.toLowerCase()];
};
